import { AppRouteProps } from "@harea/component"
import React from "react"

const AvenantDetailsContainer = React.lazy(() => import("./container/AvenantDetailsContainer"))

export const AvenantRoutes: Array<AppRouteProps> = [
    {
        path: "contracts/avenant/:id/details",
        title: "Harea.Contract.Avenant.Details.Title",
        element: <AvenantDetailsContainer />,
        roles: ["CONTRACT", "CONTRACT_CREATE"],
    },
]
